<template>
  <el-container class="p-wrap p-clearfix">
    <el-footer class="p-con p-clearfix">
      <el-row class="p-clearfix">
        <el-col :span="8">
        <ul class="p-pro p-clearfix">
          <li>主要产品</li>
          <li> <router-link :to="{path: '/product'}">远程会诊系统</router-link></li>
          <li><router-link :to="{path: '/product'}">互联网医院系统</router-link></li>
        </ul>
        </el-col>
        <el-col :span="8">
        <ul class="p-pro">
          <li>联系我们</li>
          <li><router-link to='/pIndex'>中卫佰医科技有限公司</router-link></li>
          <li>服务热线: 400-631-9377</li>
          <li><router-link to='/about'>关于我们</router-link></li>
        </ul>
        </el-col>
        <el-col :span="8">
        <ul class="p-pro p-pro-three p-pro-down">
          <li>扫码下载</li>
          <li class="p-img-box p-down-img"><img src="./../../assets/Pc/pcImg/WechatIMG2748.png" alt=""></li>
          <li>佰医APP</li>
        </ul>
        <ul class="p-pro p-pro-three">
          <li>扫码关注</li>
          <li class="p-img-box"><img src="./../../assets/Pc/pcImg/baiyi.jpg" alt=""></li>
          <li>佰医微信公众号</li>
        </ul>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
        <ul class="p-img-list">
          <li v-for="(item, index) in imgList" :key="index"><a target="_blank" :key="index"  :href="item.srcA"><img :src="item.srcImg" alt=""></a></li>
        </ul>
        </el-col>
      </el-row>

      <div class="p-footer ">
        <p class="p-fotCor">Corpyright © 中卫佰医科技有限公司版权所有 <a class="link" href="https://beian.miit.gov.cn/" target="_blank">京ICP备17062576号-2</a></p>
        <p class="p-fotShe">服务声明：专家咨询建议仅供参考_不能作为诊断及医疗的依据</p>
        <a class="p-fotA" href="javascript:;"> <img src="./../../assets/Pc/pcImg/Bitmap.png" /> 京公网安备 11010802017313号</a>
      </div>
    </el-footer>
  </el-container>
</template>
<script>
export default {
  data() {
    return {
      imgList: [
        {
          srcA: "http://www.cyberpolice.cn/wfjb/",
          srcImg: require("./../../assets/Pc/icon1.png")
        },
        {
          srcA: "",
          srcImg: require("./../../assets/Pc/icon2.png")
        },
        {
          srcA: "",
          srcImg: require("./../../assets/Pc/icon3.png")
        },
        {
          srcA: "",
          srcImg: require("./../../assets/Pc/icon4.png")
        },
        {
          srcA: "",
          srcImg: require("./../../assets/Pc/icon5.png")
        },
        {
          srcA: "https://ss.knet.cn/verifyseal.dll?sn=e18092611010075395gdug000000&comefrom=trust&trustKey=dn&trustValue=www.chinachdu.com",
          srcImg: require("./../../assets/Pc/icon6.png")
        },
      ]
    };
  },
  methods: {}
};
</script>
<style lang="less" scoped>
.p-wrap {
  height: 300px;
  background:linear-gradient(89deg,rgba(30,97,227,1),rgba(68,87,192,1)); font-size: 12px; font-family: PingFangSC-Light;
  .p-con {
    width: 1000px;
    margin: 0 auto;
    .p-pro-three{
      margin: 18px 0px 0 22px!important;
      display:inline-block;
      li{
        text-align:center;
      }
    }
    .p-pro-down{
      margin-left:74px!important;
    }
    .p-pro {
      margin: 18px 0px 0 36px; font-size: 12px;font-family:PingFangSC-Light;
      li {
        font-weight: 300;
        color: rgba(255, 255, 255, 1);
        margin-bottom: 18px; opacity: 0.9;
        &:last-child{
          margin-bottom: 0px;
        }
        a{
          color: rgba(255, 255, 255, 1);
        }
        img {
          width: 74px;
          height: 74px;
        }
        &:nth-child(1) {
          font-size: 14px;
        }
      }
      .p-img-box {
        height: 74px;
        margin-bottom: 10px;
      }
      .p-down-img{
        width:74px;
        height:74px;
        background:#fff;
        img{
          width:58px;
          height:58px;
          margin:8px;
        }
      }
    }
    .p-img-list {
      margin: 26px -36px 18px!important;
      width: 1000px;
      li {
        width: 112px;
        height: 40px;
        display: inline-block;
        margin-right: 40px;
        &:nth-child(1) {
          margin-left: 72px;
        }
      }
      // margin: 43px 0 55px;
      a {
        width: 120px;
        height: 43px;
        display: inline-block;
        img {
          width: 100%;
          height: 100%;
          opacity: 0.8;
        }
      }
    }
  }
}
.p-footer{
  height:64px;
}
.p-fotCor {
  height: 17px;
  font-size: 12px;
  color: #fff;
  font-family: PingFangSC-Light;
  line-height: 17px;
  text-align: center;
  opacity: 0.9;
  .link {
    color: #fff;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
}

.p-fotShe {
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Light;
  color: #fff;
  line-height: 17px;
  text-align: center;
  margin: 7px 0;
  opacity: 0.9;

}

.p-fotA {
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Light;
  color: #fff;
  line-height: 17px;
  text-align: center;
  display: block;
  opacity: 0.9;
}
</style>
